<template>
    <div>
        <dx-grid
            :url="url"
            :columns="columns"
            :title="title"
            ref="grid"
            :actions="actions"
            :beforeSetupGrid="beforeSetupGrid"
            :onRowClicked="onRowClicked"
            :onCellPrepared="onGridCellPrepared"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
        ></dx-grid>

        <v-dialog persistent v-model="assignAppointmentDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0 pb-2">{{
                    clickedRow.appointmentDate
                        ? "Unassign Appointment"
                        : "Assign Appointment"
                }}</v-card-title>
                <div class="pb-3">
                    {{ clickedRow.hebName + " " + clickedRow.lastNameH }}
                </div>

                <div v-if="!clickedRow.appointmentDate">
                    <v-date-picker
                        style="border: 2px solid #4caf50; border-radius: unset;"
                        v-model="selectedAppointmentDate"
                        class=""
                        width="360"
                        :events="appointmentSlotEvents"
                        @input="appointmentDateSelected"
                    ></v-date-picker>
                    <v-select
                        class="mt-3"
                        v-model="selectedAppointmentTime"
                        label="Time"
                        :items="appointmentTimes"
                    ></v-select>
                </div>
                <v-card-actions class="mx-0 px-2 pb-2 mt-2">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="reset()">Cancel</v-btn>
                    <v-btn
                        :loading="processing"
                        color="success"
                        v-if="!clickedRow.appointmentDate"
                        @click="saveAppointment()"
                    >
                        Save
                    </v-btn>
                    <v-btn
                        :loading="processing"
                        color="success"
                        v-if="clickedRow.appointmentDate"
                        @click="unassignAppointment()"
                    >
                        Unassign Appointment
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { groupBy } from "../utils/helpers.js";
import moment from "moment";

export default {
    data: () => ({
        title: "Students",

        actions: [],
        url: "",
        intervalID: "",
        userBranch: "",
        clickedRow: "",
        processing: false,
        date: "",

        assignAppointmentDialog: false,

        appointmentSlots: [],
        appointmentSlotEvents: [],
        appointmentTimes: [],
        selectedAppointmentDate: "",
        selectedAppointmentTime: "",
        regID: "",

        columns: [
            {
                label: "First Name H",
                field: "hebName",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Last Name H",
                field: "lastNameH",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Father Hebrew",
                field: "fatherH",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Address",
                field: "address1",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Home Phone",
                field: "homePhone",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Grade",
                field: "class",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Section",
                field: "section",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Last Name",
                field: "lastName",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "First Name",
                field: "engName",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Student ID",
                field: "studentID",
                link: "StudentView",
                format: "",
                template: "link-cell-template",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "familyID",
                label: "Account ID",
                link: "Account View",
                format: "",
                template: "link-cell-template",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Teacher",
                field: "teacher",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Appointment Date",
                field: "appointmentDate",
                type: "date",
                format: "MM/dd/yyyy",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Appointment Time",
                field: "appointmentTime",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Time Sort",
                field: "timeSort",
                visible: false,
                //type: "time",
                //format: "hh:mm:ss a",
                sortOrder: "asc",
                sortIndex: 0,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    async created() {
        // this.columns.find(
        //     (c) => c.field == "familyID"
        // ).showLink = this.showLink;

        this.loadAppointmentSlots();

        this.setDate();
    },
    mounted() {
        this.intervalID = setInterval(() => {
            //this.setDate();

            // if (this.$refs && this.$refs.grid) {
            //     this.$refs.grid.reloadGrid();
            // }
            location.reload();
        }, 300000);
    },
    beforeDestroy() {
        clearInterval(this.intervalID);
    },
    methods: {
        onRowClicked(row) {
            if (!this.allowChangingAppointment()) return;

            this.clickedRow = row;

            this.assignAppointmentDialog = true;
        },
        async beforeSetupGrid() {
            this.setDate();

            await this.loadRegID();

            const terms = await this.getTerms();

            this.actions.push({
                text: "Select Term",
                type: "select",
                values: terms,
                value: this.regID,
                onSelected: this.onTermSelected,
            });

            this.actions.push({
                align: "left",
                type: "text",
                getText: this.getDateFilter,
            });

            this.actions.push({
                text: "Today",
                name: "Today",
                action: () => this.onDateSelected("Today"),
                isButtonClicked: () => this.isButtonClicked("Today"),
            });

            this.actions.push({
                text: "Tomorrow",
                name: "Tomorrow",
                action: () => this.onDateSelected("Tomorrow"),
                isButtonClicked: () => this.isButtonClicked("Tomorrow"),
            });

            this.actions.push({
                text: "All",
                name: "All",
                action: () => this.onDateSelected("All"),
                isButtonClicked: () => this.isButtonClicked("All"),
            });

            this.userBranch = this.$store.state.authentication.branch;

            this.url =
                "NotAssinedStudents?date=" +
                this.getDate(this.date) +
                "&regID=" +
                this.regID +
                (this.userBranch != "null"
                    ? "&branch=" + this.userBranch
                    : "&branch=");
        },
        async loadRegID() {
            this.regID = await this.$http.get(
                "api/NotAssinedStudents/getRegID",
            );
        },
        async getTerms() {
            return await this.$http.get("api/allStudents/getRegTerms");
        },
        onTermSelected(value) {
            this.regID = value;

            this.url =
                "NotAssinedStudents?date=" +
                this.getDate(this.date) +
                "&regID=" +
                this.regID +
                (this.userBranch != "null"
                    ? "&branch=" + this.userBranch
                    : "&branch=");

            this.$refs.grid.reloadDataSource(this.url);
        },
        isButtonClicked(value) {
            return this.date == value;
        },
        setDate() {
            const now = new Date();

            this.date = now.getHours() >= 14 ? "Tomorrow" : "Today";

            if (this.$refs.grid) {
                this.onDateSelected(this.date);
            }
        },
        onDateSelected(value) {
            console.log(value);

            this.date = value;

            this.url =
                "NotAssinedStudents?date=" +
                this.getDate(this.date) +
                "&regID=" +
                this.regID +
                (this.userBranch != "null"
                    ? "&branch=" + this.userBranch
                    : "&branch=");

            this.$refs.grid.reloadDataSource(this.url);
        },
        getDateFilter() {
            return (
                '<div class="font-weight-medium subheading mb-0 pb-0">Filtered For:  ' +
                this.date +
                "</div>"
            );
        },
        getDate(value) {
            const yesterday = moment()
                .subtract(1, "day")
                .format("L");
            const today = moment().format("L");
            const tomorrow = moment()
                .add(1, "day")
                .format("L");

            switch (value) {
                case "Yesterday":
                    return yesterday;
                case "Today":
                    return today;
                case "Tomorrow":
                    return tomorrow;
                case "All":
                    return "";
            }
        },
        allowChangingAppointment() {
            const roles = Array.isArray(this.$store.state.authentication.roles)
                ? this.$store.state.authentication.roles
                : this.$store.state.authentication.roles
                ? this.$store.state.authentication.roles.split(",")
                : [];

            return roles.includes("Appointment Admin");
        },
        async loadAppointmentSlots() {
            const response = await this.$http.get(
                "api/appointments/loadExistingAppointments?source=590&branch=" +
                    this.userBranch,
            );

            this.appointmentSlots = response
                .filter((a) => !a.studentID)
                .map((appointment) => {
                    appointment.date = moment(appointment.date).format(
                        "YYYY-MM-DD",
                    );

                    appointment.title =
                        appointment.time +
                        (appointment.studentID
                            ? " - " +
                              appointment.hebName +
                              " " +
                              appointment.lastNameH
                            : "");

                    return appointment;
                });

            console.log(this.appointmentSlots);

            this.appointmentSlotEvents = Object.keys(
                groupBy(this.appointmentSlots, "date"),
            ).map((key) => {
                const date = new Date(key);
                return date.toISOString().substr(0, 10);
            });
        },
        appointmentDateSelected(date) {
            this.appointmentTimes = this.appointmentSlots
                .filter((a) => a.date == date)
                .map((a) => a.time);
        },
        async saveAppointment() {
            if (!this.selectedAppointmentDate) {
                return this.$notify({
                    text: "No Date Selected",
                    group: "notification",
                    type: "error",
                });
            }

            if (!this.selectedAppointmentTime) {
                return this.$notify({
                    text: "No Time Selected",
                    group: "notification",
                    type: "error",
                });
            }

            const slot = this.appointmentSlots.find(
                (a) =>
                    a.date == this.selectedAppointmentDate &&
                    a.time == this.selectedAppointmentTime,
            );

            if (!slot) return;

            try {
                this.processing = true;

                const appointment = JSON.parse(JSON.stringify(slot));

                appointment.studentID = this.clickedRow.studentID;
                appointment.familyID = this.clickedRow.accountID;
                appointment.source = "590";

                await this.$http.post("api/appointments/save", appointment);

                this.$refs.grid.reloadGrid();

                this.processing = false;

                this.reset();
            } catch (e) {
                this.processing = false;
            }
        },
        async unassignAppointment() {
            try {
                this.processing = true;

                const slot = await this.$http.get(
                    "api/appointments/getByID?id=" +
                        this.clickedRow.appointmentID,
                );

                if (!slot) {
                    this.processing = false;

                    return;
                }
                const appointment = JSON.parse(JSON.stringify(slot));

                appointment.studentID = null;
                appointment.familyID = null;
                appointment.source = "590";

                await this.$http.post("api/appointments/save", appointment);

                this.$refs.grid.reloadGrid();

                this.processing = false;

                this.reset();
            } catch (e) {
                this.processing = false;
            }
        },
        onGridCellPrepared(e) {
            if (e.rowType != "data" || !e.data || !e.cellElement) return;

            if (this.isPacificSummerSection(e.data.section)) {
                e.cellElement.style.setProperty(
                    "background-color",
                    "#efe1ff",
                    "important",
                );
                e.cellElement.style.setProperty(
                    "color",
                    "#4a257c",
                    "important",
                );
            } else {
                e.cellElement.style.removeProperty("background-color");
                e.cellElement.style.removeProperty("color");
            }
        },
        isPacificSummerSection(section) {
            return section == "0R";
        },
        reset() {
            this.assignAppointmentDialog = false;

            this.appointmentSlots = [];
            this.appointmentSlotEvents = [];
            this.appointmentTimes = [];
            this.selectedAppointmentDate = "";
            this.selectedAppointmentTime = "";

            this.loadAppointmentSlots();
        },
    },
};
</script>
<style>
[v-cloak] {
    display: none;
}
.v-btn__content {
    color: unset;
}
</style>
